import { useFormContext } from 'react-hook-form';

import { Checkbox, Heading4, Stack, u } from '@ui';
import { useTranslate } from '@i18n';

import * as css from './LeftHanded.css';

export const LeftHanded = () => {
    const { register } = useFormContext();
    const t = useTranslate();

    return (
        <Stack
            paddingBlock={u(4)}
            paddingInline={u(3)}
            gap={u(1.5)}
            alignItems="flex-start"
            className={css.contentSurface}
            width={{ sm: '100%', lg: 'fit-content' }}
        >
            <Heading4>{t('user_settings.playing_preference_section')}</Heading4>
            <Checkbox label={t('user_settings.play_left_handed')} {...register('leftHanded')} />
        </Stack>
    );
};
